// Einzugsgebiet A & F Garten- und Landschaftsbau
// Slug: wird als URL genutzt → /garten-und-landschaftsbau-[slug]/

const locations = [
  // 0–10 km: Direktes Flensburger Umland
  {
    slug: "harrislee",
    name: "Harrislee",
    region: "Flensburg",
    distance: "ca. 3 km von Flensburg",
    intro:
      "Harrislee grenzt direkt an Flensburg – und trotzdem haben viele Hausbesitzer hier Schwierigkeiten, einen zuverlässigen Gartenbauservice zu finden. A & F ist schnell vor Ort und kennt die Bedingungen vor Ort genau.",
    services: [
      "Heckenschnitt & Heckenpflege",
      "Rasenmähen & Rasenpflege",
      "Pflasterarbeiten & Wegebau",
      "Baumschnitt & Baumpflege",
      "Gartengestaltung & Neubepflanzung",
      "Ganzjährige Gartenpflege",
    ],
  },
  {
    slug: "handewitt",
    name: "Handewitt",
    region: "Flensburg",
    distance: "ca. 8 km von Flensburg",
    intro:
      "Handewitt und seine Ortsteile – von Jarplund bis Pull – sind klassisches Einfamilienhaus-Gebiet mit großen Gärten. Genau das ist unsere Stärke: professionelle Pflege, faire Preise, direkter Kontakt.",
    services: [
      "Heckenschnitt & Heckenpflege",
      "Rasenmähen & Rasenpflege",
      "Pflasterarbeiten & Wegebau",
      "Baumschnitt & Baumpflege",
      "Gartengestaltung & Neubepflanzung",
      "Ganzjährige Gartenpflege",
    ],
  },
  {
    slug: "gluecksburg",
    name: "Glücksburg",
    region: "Flensburg",
    distance: "ca. 10 km von Flensburg",
    intro:
      "Glücksburg mit seiner Ostseeküste und den großzügigen Gärten ist seit Jahren ein fester Bestandteil unseres Einzugsgebiets. Ob Küstengarten oder klassischer Hausgarten – wir kennen die besonderen Anforderungen der Region.",
    services: [
      "Heckenschnitt & Heckenpflege",
      "Rasenmähen & Rasenpflege",
      "Pflasterarbeiten & Wegebau",
      "Baumschnitt & Baumpflege",
      "Gartengestaltung & Neubepflanzung",
      "Ganzjährige Gartenpflege",
    ],
  },
  {
    slug: "wees",
    name: "Wees",
    region: "Flensburg",
    distance: "ca. 9 km von Flensburg",
    intro:
      "Wees liegt ruhig im Angeler Hügelland nördlich von Flensburg. Wir kommen regelmäßig in die Region und freuen uns auf neue Kunden in Wees und Umgebung.",
    services: [
      "Heckenschnitt & Heckenpflege",
      "Rasenmähen & Rasenpflege",
      "Baumschnitt & Baumpflege",
      "Gartengestaltung & Neubepflanzung",
      "Ganzjährige Gartenpflege",
    ],
  },
  {
    slug: "tastrup",
    name: "Tastrup",
    region: "Flensburg",
    distance: "direkt bei Flensburg",
    intro:
      "Tastrup liegt südlich von Flensburg und gehört zu unserem Kerngebiet. Kurze Anfahrt, zuverlässige Termine – ganz unkompliziert.",
    services: [
      "Heckenschnitt & Heckenpflege",
      "Rasenmähen & Rasenpflege",
      "Pflasterarbeiten & Wegebau",
      "Gartengestaltung & Neubepflanzung",
      "Ganzjährige Gartenpflege",
    ],
  },
  {
    slug: "engelsby",
    name: "Engelsby",
    region: "Flensburg",
    distance: "Flensburger Stadtteil",
    intro:
      "Engelsby ist ein etablierter Wohnstadtteil von Flensburg mit vielen Einfamilienhäusern und gepflegten Gärten. Als lokales Unternehmen sind wir auch hier schnell und verlässlich für Sie da.",
    services: [
      "Heckenschnitt & Heckenpflege",
      "Rasenmähen & Rasenpflege",
      "Pflasterarbeiten & Wegebau",
      "Gartengestaltung & Neubepflanzung",
      "Ganzjährige Gartenpflege",
    ],
  },
  {
    slug: "weiche",
    name: "Weiche",
    region: "Flensburg",
    distance: "Flensburger Stadtteil",
    intro:
      "Weiche ist einer der größten Flensburger Stadtteile. Gerade hier schätzen unsere Kunden, dass wir schnell reagieren und keine langen Wartezeiten verursachen.",
    services: [
      "Heckenschnitt & Heckenpflege",
      "Rasenmähen & Rasenpflege",
      "Pflasterarbeiten & Wegebau",
      "Baumschnitt & Baumpflege",
      "Gartengestaltung & Neubepflanzung",
      "Ganzjährige Gartenpflege",
    ],
  },
  {
    slug: "muerwik",
    name: "Mürwik",
    region: "Flensburg",
    distance: "Flensburger Stadtteil",
    intro:
      "Mürwik – das grüne Flensburg direkt an der Förde. Unsere Kunden in Mürwik schätzen unsere Zuverlässigkeit und den persönlichen Service, den nur ein lokales Unternehmen bieten kann.",
    services: [
      "Heckenschnitt & Heckenpflege",
      "Rasenmähen & Rasenpflege",
      "Pflasterarbeiten & Wegebau",
      "Baumschnitt & Baumpflege",
      "Gartengestaltung & Neubepflanzung",
      "Ganzjährige Gartenpflege",
    ],
  },
  {
    slug: "tarup",
    name: "Tarup",
    region: "Flensburg",
    distance: "Flensburger Stadtteil",
    intro:
      "Tarup liegt im Westen Flensburgs und gehört zu unserem Stammgebiet. Von hier haben wir zahlreiche Stammkunden, die wir regelmäßig betreuen.",
    services: [
      "Heckenschnitt & Heckenpflege",
      "Rasenmähen & Rasenpflege",
      "Pflasterarbeiten & Wegebau",
      "Gartengestaltung & Neubepflanzung",
      "Ganzjährige Gartenpflege",
    ],
  },
  {
    slug: "jarplund",
    name: "Jarplund-Weding",
    region: "Flensburg",
    distance: "ca. 7 km von Flensburg",
    intro:
      "Jarplund-Weding ist eine wachsende Gemeinde nahe Flensburg mit vielen Neubauten und frisch angelegten Gärten. Wir helfen Ihnen, Ihren neuen Garten schön zu gestalten und dauerhaft zu pflegen.",
    services: [
      "Gartengestaltung & Neubepflanzung",
      "Heckenschnitt & Heckenpflege",
      "Rasenmähen & Rasenpflege",
      "Pflasterarbeiten & Wegebau",
      "Ganzjährige Gartenpflege",
    ],
  },
  {
    slug: "freienwill",
    name: "Freienwill",
    region: "Flensburg",
    distance: "ca. 15 km von Flensburg",
    intro:
      "Freienwill in der Gemeinde Mittelangeln liegt etwas weiter draußen – wir sind trotzdem für Sie da. Guter Service endet nicht an der Stadtgrenze.",
    services: [
      "Heckenschnitt & Heckenpflege",
      "Rasenmähen & Rasenpflege",
      "Baumschnitt & Baumpflege",
      "Gartengestaltung & Neubepflanzung",
      "Ganzjährige Gartenpflege",
    ],
  },
  // 10–30 km: Weiteres Einzugsgebiet
  {
    slug: "schleswig",
    name: "Schleswig",
    region: "Schleswig",
    distance: "ca. 30 km von Flensburg",
    intro:
      "Schleswig als Kreisstadt hat einen hohen Bedarf an professionellem Garten- und Landschaftsbau. A & F ist auch in Schleswig regelmäßig im Einsatz – für Privat- und Gewerbekunden.",
    services: [
      "Heckenschnitt & Heckenpflege",
      "Rasenmähen & Rasenpflege",
      "Pflasterarbeiten & Wegebau",
      "Baumschnitt & Baumpflege",
      "Gartengestaltung & Neubepflanzung",
      "Ganzjährige Gartenpflege",
    ],
  },
  {
    slug: "kappeln",
    name: "Kappeln",
    region: "Schleswig-Flensburg",
    distance: "ca. 35 km von Flensburg",
    intro:
      "Kappeln an der Schlei – eine Region mit vielen Ferienhäusern und Privatgärten direkt am Wasser. Wir übernehmen auch die regelmäßige Pflege von Gärten, die nicht ganzjährig genutzt werden.",
    services: [
      "Heckenschnitt & Heckenpflege",
      "Rasenmähen & Rasenpflege",
      "Baumschnitt & Baumpflege",
      "Gartengestaltung & Neubepflanzung",
      "Ganzjährige Gartenpflege",
    ],
  },
  {
    slug: "soerup",
    name: "Sörup",
    region: "Schleswig-Flensburg",
    distance: "ca. 20 km von Flensburg",
    intro:
      "Sörup liegt im Herzen der Angeln – einer Landschaft mit vielen Einfamilienhäusern und großen Grundstücken. Genau das ist unser Terrain.",
    services: [
      "Heckenschnitt & Heckenpflege",
      "Rasenmähen & Rasenpflege",
      "Baumschnitt & Baumpflege",
      "Gartengestaltung & Neubepflanzung",
      "Ganzjährige Gartenpflege",
    ],
  },
  {
    slug: "langballig",
    name: "Langballig",
    region: "Schleswig-Flensburg",
    distance: "ca. 15 km von Flensburg",
    intro:
      "Langballig an der Flensburger Förde ist bekannt für seine idyllische Lage. Unsere Kunden hier schätzen, dass wir Gärten mit Blick aufs Wasser ebenso professionell betreuen wie klassische Stadtgärten.",
    services: [
      "Heckenschnitt & Heckenpflege",
      "Rasenmähen & Rasenpflege",
      "Baumschnitt & Baumpflege",
      "Gartengestaltung & Neubepflanzung",
      "Ganzjährige Gartenpflege",
    ],
  },
  {
    slug: "gelting",
    name: "Gelting",
    region: "Schleswig-Flensburg",
    distance: "ca. 25 km von Flensburg",
    intro:
      "Gelting am Geltinger Noor – Natur pur, große Gärten, viele Ferienhäuser. Wir kommen regelmäßig in die Region und freuen uns auf Anfragen aus Gelting und Umgebung.",
    services: [
      "Heckenschnitt & Heckenpflege",
      "Rasenmähen & Rasenpflege",
      "Baumschnitt & Baumpflege",
      "Gartengestaltung & Neubepflanzung",
      "Ganzjährige Gartenpflege",
    ],
  },
  {
    slug: "satrup",
    name: "Satrup",
    region: "Schleswig-Flensburg",
    distance: "ca. 22 km von Flensburg",
    intro:
      "Satrup in Mittelangeln ist ein ruhiger Ort mit gepflegten Wohngebieten. Als verlässlicher Gartenbauservice aus der Region kommen wir gerne zu Ihnen nach Satrup.",
    services: [
      "Heckenschnitt & Heckenpflege",
      "Rasenmähen & Rasenpflege",
      "Baumschnitt & Baumpflege",
      "Gartengestaltung & Neubepflanzung",
      "Ganzjährige Gartenpflege",
    ],
  },
  {
    slug: "eggebek",
    name: "Eggebek",
    region: "Schleswig-Flensburg",
    distance: "ca. 28 km von Flensburg",
    intro:
      "Eggebek liegt im westlichen Schleswig-Holstein – eine ländliche Region, in der guter Gartenservice gefragt ist. Wir sind verlässlich vor Ort.",
    services: [
      "Heckenschnitt & Heckenpflege",
      "Rasenmähen & Rasenpflege",
      "Baumschnitt & Baumpflege",
      "Gartengestaltung & Neubepflanzung",
      "Ganzjährige Gartenpflege",
    ],
  },
  {
    slug: "schafflund",
    name: "Schafflund",
    region: "Schleswig-Flensburg",
    distance: "ca. 25 km von Flensburg",
    intro:
      "Schafflund und die umliegenden Dörfer gehören zum westlichen Einzugsgebiet von A & F. Wir betreuen hier Gärten aller Größen – vom kleinen Reihenhausgarten bis zum großen Landgarten.",
    services: [
      "Heckenschnitt & Heckenpflege",
      "Rasenmähen & Rasenpflege",
      "Baumschnitt & Baumpflege",
      "Gartengestaltung & Neubepflanzung",
      "Ganzjährige Gartenpflege",
    ],
  },
  {
    slug: "steinbergkirche",
    name: "Steinbergkirche",
    region: "Schleswig-Flensburg",
    distance: "ca. 20 km von Flensburg",
    intro:
      "Steinbergkirche an der Flensburger Förde – malerisch gelegen, viele Ferienhäuser und Privatgärten direkt am Wasser. Wir kennen die besonderen Anforderungen dieser Region.",
    services: [
      "Heckenschnitt & Heckenpflege",
      "Rasenmähen & Rasenpflege",
      "Baumschnitt & Baumpflege",
      "Gartengestaltung & Neubepflanzung",
      "Ganzjährige Gartenpflege",
    ],
  },
];

module.exports = locations;
